@layer reset, default, size;

@layer reset {
  :host {
    display: block;

    .gcds-fieldset {
      border: 0;
      padding: 0;
      min-inline-size: auto
    }

    legend {
      padding: 0;
    }

    slot {
      display: block;
      margin: 0;
    }
  }
}

@layer default {
  .gcds-fieldset {
    color: var(--gcds-fieldset-default-text);

    legend {
      margin: var(--gcds-fieldset-legend-margin) !important;
    }
  }
}

@layer size {
  .gcds-fieldset legend {
    &.size-h2 {
      font: var(--gcds-fieldset-legend-size-h2-desktop);

      @media only screen and (width < 48em) {
        font: var(--gcds-fieldset-legend-size-h2-mobile);
      }
    }

    &.size-h3 {
      font: var(--gcds-fieldset-legend-size-h3-desktop);

      @media only screen and (width < 48em) {
        font: var(--gcds-fieldset-legend-size-h3-mobile);
      }
    }

    &.size-h4 {
      font: var(--gcds-fieldset-legend-size-h4-desktop);

      @media only screen and (width < 48em) {
        font: var(--gcds-fieldset-legend-size-h4-mobile);
      }
    }

    &.size-h5 {
      font: var(--gcds-fieldset-legend-size-h5-desktop);

      @media only screen and (width < 48em) {
        font: var(--gcds-fieldset-legend-size-h5-mobile);
      }
    }

    &.size-h6 {
      font: var(--gcds-fieldset-legend-size-h6-desktop);

      @media only screen and (width < 48em) {
        font: var(--gcds-fieldset-legend-size-h6-mobile);
      }
    }
  }
}
